import { render, staticRenderFns } from "./FpuiSelectList.vue?vue&type=template&id=2b1ae48f&lang=pug&"
import script from "./FpuiSelectList.vue?vue&type=script&lang=js&"
export * from "./FpuiSelectList.vue?vue&type=script&lang=js&"
import style0 from "./FpuiSelectList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports